
import { useState } from "react";
import SEO from '../pages/SEO';


const leanlifeclinic = [
  "/leanlife clinic/jpeg-optimizer_MAM_6094.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6096.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6097.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6199.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6201.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6209.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6210.JPG",
  "/leanlife clinic/jpeg-optimizer_MAM_6223.JPG",
];

const generalMedicineWorkshop = [
  "/General Medicine Workshop/jpeg-optimizer_1.jpeg",
  "/General Medicine Workshop/jpeg-optimizer_2.jpeg",
  "/General Medicine Workshop/jpeg-optimizer_3.jpeg",
  "/General Medicine Workshop/jpeg-optimizer_4.jpeg",
  "/General Medicine Workshop/jpeg-optimizer_5.jpeg",
  "/General Medicine Workshop/jpeg-optimizer_6.jpeg",
  "/General Medicine Workshop/jpeg-optimizer_7.jpeg",
];



const images = [
  "/Gallery(13).jpg", "/Gallery(14).jpg", "/Gallery(15).jpg",
  "/Gallery(16).jpg", "/Gallery(17).jpg", "/Gallery(18).jpg", "/Gallery(19).jpg", "/Gallery(20).jpg",
  "/Gallery(21).jpg", "/Gallery(22).jpg", "/Gallery(23).jpg", "/Gallery(24).jpg", "/Gallery(25).jpg",
  "/Gallery(26).jpg", "/Gallery(27).jpg", "/Gallery(28).jpg", "/Gallery(29).jpg", "/Gallery(30).jpg",

];
const newsarticles = [
 "/news2.jpg","/news4.jpg","/news5.jpg","/news6.jpg","/news7.jpg","/news8.jpg","/news9.jpg",
 "/news10.jpg","/news11.jpg","/news12.jpg",
];

const cmeProgrammePediatrics = [
  "/CME Programme - Pediatrics/compressed-MAM_4993.webp",
  "/CME Programme - Pediatrics/compressed-MAM_5063 (1).webp",
  "/CME Programme - Pediatrics/MAM_5018_1_11zon.webp",
  "/CME Programme - Pediatrics/MAM_5044_7_11zon.webp",
  "/CME Programme - Pediatrics/MAM_5076_6_11zon.webp",
  "/CME Programme - Pediatrics/MAM_5137_5_11zon.webp",
  "/CME Programme - Pediatrics/MAM_5143_4_11zon.webp",
  "/CME Programme - Pediatrics/MAM_5150_3_11zon.webp",
  "/CME Programme - Pediatrics/MAM_5158_2_11zon.webp",
  "/CME Programme - Pediatrics/MAMS-optimized.png",
];

const reddyslabmeetingpics = [
  "/reddy's lab meeting pics/reddy's lab-1.jpeg",
  "/reddy's lab meeting pics/reddy's lab-2.jpeg",
  "/reddy's lab meeting pics/reddy's lab-3.jpeg",
  "/reddy's lab meeting pics/reddy's lab-4.jpeg",
  "/reddy's lab meeting pics/reddy's lab-5.jpeg",
  "/reddy's lab meeting pics/reddy's lab-6.jpeg",
];

const ophtalcpd = [
  "/ophtal cpd/2_6_11zon.jpg",
  "/ophtal cpd/3 (2)_5_11zon.jpg",
  "/ophtal cpd/3_1_11zon.jpg",
  "/ophtal cpd/6_7_11zon.jpg",
  "/ophtal cpd/8_4_11zon.jpg",
  "/ophtal cpd/9_3_11zon.jpg",
  "/ophtal cpd/10_2_11zon.jpg",
];

const fencesport = [
  "/fence sport/MAM_7440_6_11zon.jpg",
  "/fence sport/MAM_7441_5_11zon.jpg",
  "/fence sport/MAM_7461_4_11zon.jpg",
  "/fence sport/MAM_7466_3_11zon.jpg",
  "/fence sport/MAM_7468_2_11zon.jpg",
  "/fence sport/MAM_7480_1_11zon.jpg",
];

const cpdpathology = [
  "/cpd pathology/MAM_5393_4_11zon.jpg",
  "/cpd pathology/MAM_5395_3_11zon.jpg",
  "/cpd pathology/MAM_5458_2_11zon.jpg",
  "/cpd pathology/MAM_5462_1_11zon.jpg",
  "/cpd pathology2/jpeg-optimizer_2.JPG",
  "/cpd pathology2/jpeg-optimizer_4.JPG",
  "/cpd pathology2/jpeg-optimizer_5.JPG",
  "/cpd pathology2/jpeg-optimizer_6.JPG",
  "/cpd pathology2/jpeg-optimizer_7.JPG",
  "/cpd pathology2/jpeg-optimizer_8.JPG",
  "/cpd pathology2/jpeg-optimizer_9.JPG",
  "/cpd pathology2/jpeg-optimizer_10.JPG",
];
const SwasthNariInauguration = [
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-1.jpg",
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-2.jpg",
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-3.jpg",
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-pledge.jpg",
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-obs-gyn.jpg",
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-gen-medi.jpg",
  "/SWASTH NARI SASHAKT PARIVAR ABHIYAAN-INAUGURATION/swasth-nari-7.jpg",
];

const CPDCommunityMedicine = [
  "/cpd community medicine/1.jpeg",
  "/cpd community medicine/2.jpeg",
  "/cpd community medicine/3.jpeg",
  "/cpd community medicine/4.jpeg",
  "/cpd community medicine/5.jpeg",
  "/cpd community medicine/6.jpeg",
  "/cpd community medicine/7.jpeg",
  "/cpd community medicine/8.jpeg",
  "/cpd community medicine/9.jpeg",
];

const CPD = [
  
  "/website pics/jpeg-optimizer_1.JPG",
  "/website pics/jpeg-optimizer_2.JPG",
  "/website pics/jpeg-optimizer_3.JPG",
  "/website pics/jpeg-optimizer_4.JPG",
  "/website pics/jpeg-optimizer_5.JPG",
  "/website pics/jpeg-optimizer_6.JPG",
  "/website pics/jpeg-optimizer_7.JPG",
  "/website pics/jpeg-optimizer_8.JPG",
  "/website pics/jpeg-optimizer_9.JPG",
  "/website pics/jpeg-optimizer_10.JPG",
];

const NeurosurgeryExcellence = [
  
  "/Neurosurgery Excellence/jpeg-optimizer_1.JPG",
  
  "/Neurosurgery Excellence/jpeg-optimizer_3.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_4.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_5.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_6.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_7.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_8.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_9.JPG",
  "/Neurosurgery Excellence/jpeg-optimizer_10.JPG",
];

const WomensDayCelebrations = [
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations1.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations2.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations3.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations4.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations5.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations6.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations7.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations8.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations9.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations10.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations11.JPG",
  "/Women'sDayCelebrations/Women'sDayCelebrations/Women'sDayCelebrations12.JPG",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/WomensDay1.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/WomensDay2.png",
];
const Paediatrics = [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/2.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/3.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/4.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/5.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/6.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/7.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/8.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/9.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/10.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/11.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/12.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/13.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/14.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/15.jpeg",
 
];
const ENT = [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/1-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/2-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/3-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/4-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/5-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/6-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/7-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/8-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/9-1.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/05/10-1.jpeg",
  ];
const Environment = [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04092-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/EnvironmentDay2.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04153.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04155.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04164-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04188-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/8-rotated.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04212.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04228.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04239-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04323.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04331-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04337-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04345.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04352.HIF_-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04380-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/DSC04259-scaled.jpg",
];

const Inauguration = [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Untitled-design-17.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/2-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/3-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/4-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/5-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/6-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/7-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/8-1-scaled.jpg", 
   "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/9-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/10-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/11-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/12-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/13-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/14-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/15-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/16-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/17-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/18-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/19-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/22-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/23-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/24-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/25-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/26-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/27-scaled.jpg",
];
const Psychiatry= [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/1-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/2.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/3-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/4-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/5-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/6-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/7-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/8-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/9-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/10-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/11-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/12-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/13-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/14-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/15-scaled.jpeg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/16-scaled.jpeg",
];
const Yoga= [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day1-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day2-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day3-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day4-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day5-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day6-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day7-scaled.jpg",
  // "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day8-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day9-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day10-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day11-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day12-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day13-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day14-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day15-scaled.jpg",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Yoga-Day16-scaled.jpg",
];
const Surgeries= [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries1-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries2-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries3-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries4-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries5-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries6-scaled.webp", 
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries7-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/surgeries8-scaled.webp",  
];
const Medtronics= [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/1-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/3-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/4-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/5-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/6-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/7-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/8-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/9-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/10-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/11-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/12-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/13-scaled.webp",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/07/14-scaled.webp",
];
const RespiratoryMedicine= [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine1.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine2.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine3.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine4.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine5.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine6.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine7.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine8.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine9.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine10.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine11.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine12.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine13.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine14.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/RespiratoryMedicine15.png"
 
];
const Independence= [
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence1.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence6.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence8.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence9.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence10.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence11.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence12.png",
  "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/08/Independence13.png",  
 
];



 


const Gallery = () => {
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  
  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/gallery"
  },
  "headline": "MAMS Hospitals Gallery",
  "description": "Explore memorable moments from MAMS Hospitals: graduation ceremonies, hospital events, CME programmes, CPD sessions, and more.",
  "author": { "@type": "Organization", "name": "MAMS Hospitals" },
  "publisher": {
    "@type": "Organization",
    "name": "MAMS Hospitals",
    "logo": { "@type": "ImageObject", "url": "https://mamshospitals.com/MAMS-Logo.png" }
  },
  "datePublished": "2025-09-10",
  "dateModified": "2025-09-10",
  "hasPart": [
   {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6094.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6096.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6097.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6199.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6201.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6209.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6210.JPG",
      "caption": "LeanLife Clinic"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/leanlife%20clinic/jpeg-optimizer_MAM_6223.JPG",
      "caption": "LeanLife Clinic"
    },
   {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(13).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(14).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(15).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(16).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(17).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(18).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(19).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(20).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(21).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(22).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(23).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(24).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(25).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(26).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(27).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(28).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(29).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/Gallery(30).jpg",
      "caption": "Hospital Gallery"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news2.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news4.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news5.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news6.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news7.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news8.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news9.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news10.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news11.jpg",
      "caption": "News Article"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/news12.jpg",
      "caption": "News Article"
    },
     {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/compressed-MAM_4993.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/compressed-MAM_5063%20(1).webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5018_1_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5044_7_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5076_6_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5137_5_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5143_4_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5150_3_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAM_5158_2_11zon.webp",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/CME%20Programme%20-%20Pediatrics/MAMS-optimized.png",
      "caption": "CME Programme - Pediatrics"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/reddy's lab meeting pics/reddy's lab-1.jpeg",
      "caption": "Reddy's Lab Meeting"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/reddy's lab meeting pics/reddy's lab-2.jpeg",
      "caption": "Reddy's Lab Meeting"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/reddy's lab meeting pics/reddy's lab-3.jpeg",
      "caption": "Reddy's Lab Meeting"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/reddy's lab meeting pics/reddy's lab-4.jpeg",
      "caption": "Reddy's Lab Meeting"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/reddy's lab meeting pics/reddy's lab-5.jpeg",
      "caption": "Reddy's Lab Meeting"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/reddy's lab meeting pics/reddy's lab-6.jpeg",
      "caption": "Reddy's Lab Meeting"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/2_6_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/3 (2)_5_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/3_1_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/6_7_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/8_4_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/9_3_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
    {
      "@type": "ImageObject",
      "contentUrl": "https://mamshospitals.com/ophtal cpd/10_2_11zon.jpg",
      "caption": "Ophthalmology CPD"
    },
  ]
}
  
];

  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <SEO
        title="MAMS Hospital Gallery – Campus, Infrastructure & Clinical Facilities"
        description="View the photo gallery of Mamata Academy of Medical Sciences Hospital, Bachupally – showcasing hospital buildings, clinical departments, campus infrastructure and teaching spaces."
        keywords="Hyderabad's Best Multispecialty Hospital, Best Hospital near Bachupally Hyderabad, Best Hospital near Miyapur Hyderabad, Best Hospital near Nizampet, Multispecialty Hospital near KPHB Colony, Emergency Hospital near JNTU Hyderabad, 24-hour Hospital in Bachupally Hyderabad, Emergency Care Hospital in Hyderabad, Best Cardiology Hospital in Hyderabad, Best Neurology Hospital Hyderabad, Orthopaedics Hospital in Bachupally Hyderabad, Best Joint Replacement Hospital Hyderabad, Spine Surgery Specialist Hyderabad, Best ENT Hospital in Hyderabad, Best Gynecology Hospital Hyderabad, Maternity & Child Care Hospital Hyderabad, Best Pediatric Hospital in Bachupally, Neonatal ICU Hospital Hyderabad, General Medicine Specialist Hyderabad, Best General Surgery Hospital Hyderabad, Critical Care Hospital near Miyapur Hyderabad, Best Physiotherapy Hospital Hyderabad, Mamata Academy of Medical Sciences hospital,MAMS Hospital gallery, Mamata Academy Medical Sciences photos, hospital infrastructure images Hyderabad, teaching hospital campus gallery, MAMS Bachupally hospital facilities gallery"
        schema={schema}
      canonicalUrl="https://mamshospitals.com/gallery"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Gallery</h1>
            <p className="text-lg text-gray-600 mb-8">
              Celebrating the joyful moments of our graduates at Mamatha Hospital’s Graduation Ceremony.
            </p>
          </div>
        </div>
      </section>

    

      {/* Hospital */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Hospital</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= images.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Independence Day */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Independence Day</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Independence.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Surgeries ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                  index >= Independence.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Respiratory Medicine CPD Program */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Respiratory Medicine CPD Program</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {RespiratoryMedicine.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Surgeries ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                  index >= RespiratoryMedicine.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
       {/* Medtronics */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Medtronics - Skill Lab</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Medtronics.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Surgeries ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= Medtronics.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Surgeries Day */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">40+ Free TKR Surgeries, Restoring Lives</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Surgeries.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Surgeries ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= Surgeries.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Yoga Day */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6"> International Yoga Day 2026 Celebrations</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Yoga.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Yoga ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= Yoga.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Environment  */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Environment Day</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Environment.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Environment  ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= Environment .length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section> 
      {/* Psychiatry: MIDTERM CME 2026  */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Psychiatry: MIDTERM CME 2026 </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Psychiatry.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Psychiatry  ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= Psychiatry .length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section> 
      {/* Inauguration */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">MAMS Healers Bulletin Inauguration</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Inauguration.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Inauguration Image ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= Inauguration.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ENT */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">ENT</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {ENT.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >= ENT.length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section> 
      {/* CPD - Paediatrics  */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">CPD - Paediatrics</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Paediatrics.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className={`w-full h-64 sm:h-72 md:h-80 object-cover ${
                    index >=Paediatrics .length - 2 ? "object-top" : ""
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </section> 
      {/* Womens Day */}
       <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6"> Womens Day Celebrations</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {WomensDayCelebrations.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
       </section> 
       {/* generalMedicineWorkshop */}
       <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">General Medicine Workshop</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {generalMedicineWorkshop.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
       </section>
       {/* Neurosurgery Excellence – Press Meet Highlights */}
       <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Neurosurgery Excellence – Press Meet Highlights</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {NeurosurgeryExcellence.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
       </section>
       {/* CPD Program */}
       <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">CPD Program : Department of OBGY</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CPD.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
       </section>
       {/* CPD Community Medicine*/}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">CPD Community Medicine</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CPDCommunityMedicine.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Swasth Nari Inauguration*/}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Swasth Nari Inauguration</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SwasthNariInauguration.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* LeanLife Clinic */}
      <section className="py-10">
              <div className="container mx-auto px-4 max-w-6xl">
                <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">LeanLife Clinic</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {leanlifeclinic.map((src, index) => (
                    <div
                      key={index}
                      className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                      onClick={() => setSelectedImage(src)}
                    >
                      <img
                        src={src}
                        alt={`Gallery Image ${index + 1}`}
                        className="w-full h-64 sm:h-72 md:h-80 object-cover"
                      />
                    </div>
                  ))}
                </div>
              </div>
      </section>
      {/*CME Programme - Pediatrics*/}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">CME Programme - Pediatrics</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cmeProgrammePediatrics.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/*Reddy's Lab Meeting*/}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Reddy's Lab Meeting</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {reddyslabmeetingpics.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/*CPD Pathology*/}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">CPD Pathology</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cpdpathology.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* News Articles */}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">News Articles</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {newsarticles.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Fence Sport</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {fencesport.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section> */}


      {/*Ophtal CPD*/}
      <section className="py-10">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Ophtal CPD</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {ophtalcpd.map((src, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                onClick={() => setSelectedImage(src)}
              >
                <img
                  src={src}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal Preview */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-3xl w-full mx-4">
            <img
              src={selectedImage}
              alt="Preview"
              className="w-full max-h-[90vh] object-contain rounded-lg"
            />
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-2 right-2 text-white text-2xl font-bold"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default Gallery;
